import React from 'react';
import { Link, Grid } from '@mui/material';

import { postMetaConverter } from '@shared/services/meta';
import { useSelector } from 'react-redux';

import PlateContent from './PlateContent';

const PlateBox = ({ data, typePlate }) => {
  const infoPlaca = data;
  const user = useSelector(store => store.userInfo);

  const no_open = data?.search_link?.trim().toUpperCase() === 'NO ABRIR';

  return (
    <Grid
      item
      sx={{
        cursor: no_open ? 'default' : 'pointer',
        display: { xs: 'flex', sm: 'block' },
        justifyContent: { xs: 'center', sm: 'initial' },
      }}
      data-testid="placa_container"
    >
      {no_open ? (
        <PlateContent {...{ data }} />
      ) : (
        <Link
          underline="none"
          target="_blank"
          onClick={() => {
            const value = {
              link: infoPlaca.search_link
                ? data.search_link
                : `/plates/${infoPlaca.id}/detail?type=${typePlate}`,
              title: infoPlaca.title,
              id: infoPlaca.id,
            };
            window.dataLayer.push({
              event: 'clickPlaca',
              eventProps: {
                category: 'placa',
                action: 'abrir placa',
                label: 'placa',
                value,
              },
            });
            postMetaConverter(
              {
                event_name: 'clickPlaca',
                custom_data: {
                  category: 'placa',
                  action: 'abrir placa',
                  label: 'placa',
                  ...value,
                },
              },
              user
            );
          }}
          href={
            infoPlaca.search_link
              ? data.search_link
              : `/plates/${infoPlaca.id}/detail?type=${typePlate}`
          }
        >
          <PlateContent {...{ data }} />
        </Link>
      )}
    </Grid>
  );
};

export default PlateBox;
